import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FiLocaleService } from '@fi-shared/fi-locale.service';
import { ISmsCostsPeriod } from '@fi-app/sms/sms-costs/sms-costs';
import { getLastItem } from '@fi-shared/utils/get-last-Item';

@Component({
    selector: 'fi-sms-costs-select-period',
    templateUrl: './select-period.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiSmsCostsSelectPeriodComponent implements OnInit {
    @Input() period: ISmsCostsPeriod;
    @Output() periodChange = new EventEmitter<ISmsCostsPeriod>();

    periods: ISmsCostsPeriod[] = [];
    value: ISmsCostsPeriod;

    constructor(private fiLocaleService: FiLocaleService) {}

    ngOnInit(): void {
        for (let i = 0; i < 12; i++) {
            const date = new Date();
            date.setMonth(date.getMonth() - i);
            this.periods.unshift({
                month: date.getMonth(),
                year: date.getFullYear(),
            });
        }

        if (this.period) {
            this.value = this.periods.find(
                (period) => period.year === this.period.year && period.month === this.period.month,
            );
        }

        if (!this.value) {
            this.value = getLastItem(this.periods);
        }
    }

    getPeriodTitle(period: ISmsCostsPeriod) {
        const date = new Date(period.year, period.month);
        return this.fiLocaleService.getMonthName(date.getMonth()) + ', ' + date.getFullYear();
    }

    onValueChange($event) {
        this.periodChange.emit($event);
    }
}
